export default class NewFolderRequest {
  public name: string = "";
  public projectId: string = "";
  public parentFolderId: string = "";
  public serviceId: string = "";

  public toFormData(): FormData {
    const d = new FormData();
    d.append("id", "");
    d.append("kind", "folder");
    d.append("name", this.name);
    d.append("projectId", this.projectId);
    d.append("parentFolderId", this.parentFolderId);
    d.append("serviceId", this.serviceId);
    return d;
  }
}
